import { Box, Tooltip } from "@mui/material";
import Image from "next/image";
import React, { useContext, useEffect, useState } from "react";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import HaveQuestions from "../HaveQuestions";
import { LocalizationContext } from "src/lib/context";
import ReactSimplyCarousel from "react-simply-carousel";
import DronerMobileReference from "@components/Compare/DronerMobileReference";

const CompareMobile = ({
  dronersToCompare,
  droners,
  setCompareItems,
  removeCompareUrlParameter,
  compareItems,
  helperItems,
}: {
  dronersToCompare: any;
  droners: string[];
  setCompareItems: any;
  removeCompareUrlParameter: any;
  compareItems: string[];
  helperItems: any;
}) => {
  const updatedHelperItems = [
    ...helperItems.workAreaInfo,
    ...helperItems.technicalInfo,
    ...helperItems.reference,
  ];

  const { localeStrings } = useContext(LocalizationContext);
  const [activeSlide, setActiveSlide] = useState(0);
  const [currentDroner, setCurrentDroner] = useState(dronersToCompare[0]);

  useEffect(() => {
    setCurrentDroner(dronersToCompare[activeSlide]);
  }, [activeSlide, dronersToCompare]);

  return (
    <div className="compare__mobile">
      <button className="compare__mobile--addButton">
        <img src="/assets/add-icon.svg" alt="" />
        <h6 className="subtitle-3 white">
          Új hozzáadása ({activeSlide + 1}/{dronersToCompare.length})
        </h6>
      </button>

      <div className="compare__mobile--top">
        <ReactSimplyCarousel
          containerProps={{
            style: {
              position: "absolute",
              width: "100%",
              left: "0",
              right: "0",
              userSelect: "text",
              columnGap: "54px !important",
            },
          }}
          activeSlideIndex={activeSlide}
          onRequestChange={(active) => setActiveSlide(active)}
          forwardBtnProps={{
            show: false,
          }}
          backwardBtnProps={{
            show: false,
          }}
          dotsNav={{
            show: true,
            itemBtnProps: {
              style: {
                marginTop: "25px",
                height: 7,
                width: 7,
                borderRadius: "50%",
                padding: 0,
                marginLeft: 4,
                marginRight: 4,
                background: "#2496cc",
              },
            },
            activeItemBtnProps: {
              style: {
                marginTop: "25px",
                height: 8,
                width: 8,
                marginLeft: 4,
                marginRight: 4,
                borderRadius: "50%",
                border: 0,
                background: "#2496cc",
                padding: 0,
              },
            },
          }}
          itemsToShow={dronersToCompare.length < 4 ? 2 : 3}
          centerMode={true}
          infinite={true}
          autoplay={true}
          delay={4000}
          updateOnItemClick={true}
        >
          {dronersToCompare.length > 0 &&
            dronersToCompare.map((droner: any, i: number) => (
              <div
                style={{ padding: "0 20px" }}
                className="compare__droner"
                key={droner.id}
              >
                <Image
                  src={droner.profImage ?? "/assets/profile_placeholder.svg"}
                  alt=""
                  width={activeSlide == i ? 120 : 90}
                  height={activeSlide == i ? 120 : 90}
                  style={{ borderRadius: "10px" }}
                />
                <h3
                  className="compare__primaryText"
                  children={droner.displayName}
                />
                <Box>
                  <h5 className="body-2">{droner.contactEmail}</h5>
                  <h5 className="body-2">
                    {droner.phone ? `+${droner.phone}` : "__"}
                  </h5>
                  <button
                    className="compare__remove"
                    style={{ margin: "5px auto" }}
                    // Remove the droner from the comparison when clicked and update the DOM
                    onClick={() => {
                      setCompareItems(
                        compareItems.filter((i: string) => i !== droner.uid)
                      );
                      removeCompareUrlParameter(droner.uid);
                      setActiveSlide(0);
                      setCurrentDroner(dronersToCompare[0]);
                    }}
                  >
                    Remove
                  </button>
                </Box>
              </div>
            ))}
        </ReactSimplyCarousel>
      </div>

      <div className="compare__mobile--main" style={{ marginTop: "296px" }}>
        {updatedHelperItems.map((item: any, i: number) => (
          <div className="compare__mobile--main-item" key={i}>
            <div className="compare__leftColumn--item">
              <Image
                src={`/assets/${item.image}.png`}
                alt=""
                width="24"
                height="24"
              />
              <h3 className="compare__primaryText">{item.text}</h3>
              {item.tooltip && (
                <Tooltip
                  title={item.tooltip}
                  sx={{ width: "12px", height: "12px", marginLeft: "-4px" }}
                >
                  <InfoOutlinedIcon />
                </Tooltip>
              )}
            </div>
            <h5 className="compare__secondaryText">
              {item.text == "Location" ? currentDroner?.address : ""}
              {item.text == "Free distance"
                ? `${currentDroner?.freeDist} KM`
                : ""}
              {item.text == "Max. distance"
                ? `${currentDroner?.maxRange} KM`
                : ""}
              {item.text == "Certification" ? (
                <>
                  {currentDroner?.userCertificate ? (
                    <a
                      href={currentDroner?.userCertificate}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <Image
                        src="/assets/pdf-icon.png"
                        width="32"
                        height="32"
                        alt=""
                      />
                    </a>
                  ) : (
                    "-"
                  )}
                </>
              ) : (
                ""
              )}
              {item.text == "Equipment" ? (
                <>
                  {currentDroner?.equipment?.map((equipment: any) => (
                    <>{equipment}</>
                  ))}
                </>
              ) : (
                ""
              )}
              {item.text == "Software" ? "DJI TERRA ADVANCED" : ""}
              {item.text == "Social" ? (
                <>
                  <div className="compare__social">
                    {/* <Image */}
                    {/*   src="/assets/facebookIconFill.png" */}
                    {/*   alt="" */}
                    {/*   width="24" */}
                    {/*   height="24" */}
                    {/* /> */}
                    {/* <Image */}
                    {/*   src="/assets/instagramIconFill.png" */}
                    {/*   alt="" */}
                    {/*   width="24" */}
                    {/*   height="24" */}
                    {/* /> */}
                    {/* <Image */}
                    {/*   src="/assets/youtubeIconFill.png" */}
                    {/*   alt="" */}
                    {/*   width="24" */}
                    {/*   height="24" */}
                    {/* /> */}
                    {/* <Image */}
                    {/*   src="/assets/linkedinIconFill.png" */}
                    {/*   alt="" */}
                    {/*   width="24" */}
                    {/*   height="24" */}
                    {/* /> */}
                  </div>
                </>
              ) : (
                ""
              )}
              {item.text == "References" ? (
                <>
                  <div className="compare__reference">
                    <DronerMobileReference droner={currentDroner} />
                  </div>
                </>
              ) : (
                ""
              )}
            </h5>
          </div>
        ))}
      </div>

      <HaveQuestions email={localeStrings?.errorPage?.mailToLink} />
    </div>
  );
};

export default CompareMobile;
